export default __webpack_public_path__ + "static/media/architecture-img-13.6c85e52a.jpg";